// Fallback for when the HTTP fetch of the matching file under
// src/assets/data/print-labels-data/label/ fails. GENERATED FROM THAT FILE - keep
// the two identical: a drifted copy means a fetch failure quietly prints a
// different label, which is the worst moment to find the difference.
export const DEFAULT_DYMO_TEMPLATE: string = `
<!--
  Per-container Dymo label, 3in x 1in. ONE OF THESE PRINTS PER PHYSICAL CONTAINER.

  {{containerCaption}} ("BOX 2 of 3") and {{itemQr}} (inline SVG) are filled per
  item by PrintService.fillItemSlots, after the {{key}} fields below have been
  populated from the log. On a legacy log with no item rows both are emptied and
  the label falls back to the whole-delivery quantity alone.

  The company logo that used to share line 4 with the quantity was dropped to
  make room for the QR code: 3in x 1in has no spare space, and a code that
  identifies the box outranks a mark that does not. populateTemplate still
  handles {{logoPath}} if it is ever restored.
-->
<div class="dymo-label">
  <div class="label-text">
    <div class="line line-ids">
      <span class="job-number">{{jobNumber}}</span>
      <span class="po">PO: {{poNumber}}</span>
    </div>
    <div class="line line-container">
      <span class="container">{{containerCaption}}</span>
      <span class="qty">{{qtyUnits}}</span>
    </div>
    <div class="line line-detail">
      <span class="job-name">Job: {{jobName}}</span>
    </div>
    <div class="line line-detail">
      <span class="vendor">Ven: {{vendor}}</span>
      <span class="date">{{dateIn}}</span>
    </div>
    <div class="line line-detail">
      <span class="tech">Tech: {{contact}} - {{shelfLocation}}</span>
    </div>
  </div>
  <div class="qr-box">{{itemQr}}</div>
</div>
`;
